import React from 'react';
import PropTypes from 'prop-types';
import { makeWidget } from '@typeform/embed';
import cn from 'classname';
import _get from 'lodash/get';

export default class Poll extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isVisible: false
		};
	}
	componentDidMount() {
		if (this.container && this.props.pollUrl) {
			this.setState({ isVisible: true });
			makeWidget(this.container, this.props.pollUrl, {
				hideFooter: true,
				hideHeaders: true
			});
		}
	}
	componentDidUpdate() {
		let answeredPollIDs = this.props.user.general.answered_poll_ids;
		let isPollAnswered = this.props.pollUrl && answeredPollIDs.reduce((prev, curr) => {
			return prev || this.props.pollUrl.indexOf(curr) !== -1;
		}, false);

		isPollAnswered && this.setState({ isVisible: false });
	}
	render() {
		const isRegisteredWithOffers = !!_get(this.props, 'user.general.available_offers.length')
			&& _get(this.props, 'user.general.level') === 'registered';
		return !isRegisteredWithOffers && (
			<div className={cn({ 'container__content polls': true, 'visible': this.state.isVisible })}>
				<div
					ref={container => (this.container = container)}
					className="poll-container"
					style={{ width: '100%', height: '500px' }}
				/>
			</div>
		);
	}
}

Poll.propTypes = {
	pollUrl: PropTypes.string,
	user: PropTypes.object
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/dashboard/components/polls.js